import React, { useEffect } from "react";
import { observer } from "mobx-react";
import "primeflex/primeflex.css";
import { EnhancedReportsViewModel } from "./EnhancedReportsViewModel";
import Utils from "../../infrastructure/Utils";
import "./EnhancedReportsView.css";
import UserContext from "../../infrastructure/UserContext";
import { routes } from "../../router";
import { respondToAuthCacheRequest } from "../../infrastructure/authCacheRelay";
import { getToken } from "../../infrastructure/Auth0Authenticator";

// Plain function component, deliberately NOT wrapped in observer(): this
// codebase's mobx-react@5 wraps observer() function components as class
// components under the hood, and hooks can't run inside a class component's
// render() (see MarketersView.tsx's MarketersAuthRelay for the same trap).
const EnhancedReportsAuthRelay: React.FC<{ reportsBaseUrl: string }> = ({
  reportsBaseUrl,
}) => {
  useEffect(() => {
    // Warm this token now, before the iframe's REQUEST_AUTH_CACHE arrives.
    // getToken() serializes through acquireToken()'s Web Lock, which is also
    // queued behind every other API call this page fires on load - asking
    // for it lazily inside respondToAuthCacheRequest means it can lose the
    // child's cold-load timeout race.
    getToken().catch(() => {});

    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== reportsBaseUrl) return;
      respondToAuthCacheRequest(event, reportsBaseUrl);
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [reportsBaseUrl]);

  return null;
};

export const EnhancedReportsView: React.FC<{
  vm: EnhancedReportsViewModel;
}> = observer((props) => {
  let env = Utils.getAppHostKey();
  let reportsUrl =
    `https://reporthub-${env}.integrityconnect.com/app?tenantName=${Utils.getBUName()}&connectUserId=${UserContext.getUserId()}`
      .replace("-prod", "");
  // let reportsUrl = `http://localhost:3003/app`; // enable only for local development
  const reportsBaseUrl = new URL(reportsUrl).origin;

  return (
    <>
        <div className="er-container">
          <EnhancedReportsAuthRelay reportsBaseUrl={reportsBaseUrl} />
          <iframe src={`${reportsUrl}`} id="bob-iframe" frameBorder="0" />
        </div>
    </>
  );
});
